import React from 'react';
import styled from 'styled-components';
import oligoLogo from '../resource/oligo-logo.svg';

const Logo = styled.img`
  margin: 0 auto 20px;
  display: block;
  height: 83px;
  cursor: pointer;

  @media (max-width: 600px) {
    height: 65px;
  }
`;

export const HeroLogo = ({ logo = oligoLogo, redirectPath = '/', ...others }) => {
  return <a {...others} onClick={() => window.location=redirectPath+window.location.search}>
    <Logo src={logo} alt="Hero Logo" />
  </a>
};
